export const BRAND = {
  name: "HYLAS COMPANION",
  short: "HYLAS",
  tagline: "Drive New Trucks. Earn More.",
  phone: "(708) 395-9565",
  email: "contact@hylascompanion.com",
};

export const IMAGES = {
  heroTruck: "https://i.postimg.cc/T25F5hJG/man-working-as-truck-driver.jpg",
  sunsetHighway: "https://images.unsplash.com/photo-1652717036649-e78e42218dbb?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  scania: "https://images.unsplash.com/photo-1670509295484-df0c2512fec4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bluePeterbilt: "https://images.unsplash.com/photo-1591768793355-74d04bb6608f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  blackTruck: "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  redTruck: "https://images.unsplash.com/photo-1720811559395-3ed8d1b16649?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  byTrailer: "https://images.unsplash.com/photo-1505165697550-710e168b709d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  driver1: "https://images.unsplash.com/photo-1626712211690-8de4fe30177c?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  driver2: "https://images.unsplash.com/photo-1633665503034-78f3628a86e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  driver3: "https://images.unsplash.com/photo-1762095996527-126e49ef9d72?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
};

export const NAV = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Positions", path: "/positions" },
  { label: "Fleet", path: "/fleet" },
  { label: "Pay & Benefits", path: "/pay-benefits" },
  { label: "FAQ", path: "/faq" },
  { label: "Blog", path: "/blog" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "How It Works", path: "/how-it-works" },
  { label: "Apply", path: "/apply" },
  { label: "Track", path: "/track" },
  { label: "Contact", path: "/contact" },
];

export const POSITIONS = [
  {
    key: "company-driver",
    title: "Company Driver",
    blurb: "Start earning immediately in our equipment. Zero out-of-pocket, top CPM rates, and full company support coast to coast.",
    points: ["85¢+ per mile (CPM)", "$1 CPM Team Driving", "30%+ per practical load (PPL)", "Weekly settlements"],
  },
  {
    key: "lease-rent",
    title: "Lease & Rent",
    blurb: "Ownership or flexible rental — both at 88% revenue share with driver-first terms and real walk-away protection.",
    points: ["88% Lease To Own", "88% Rent Program", "Walk-away friendly terms", "Real path to ownership"],
  },
  {
    key: "local-regional",
    title: "Local & Regional",
    blurb: "Home more often. W2 pay, hourly rates, and weekly guaranteed income that keeps you close to what matters.",
    points: ["$1,200–2,500/wk W2", "$30/hr Local Positions", "Daily or weekly home time", "Steady freight, zero guesswork"],
  },
  {
    key: "entry-level",
    title: "Entry Level",
    blurb: "No OTR experience? No CDL? We have a lane for you. Start earning fast and build toward the career you want.",
    points: ["$650–950/wk Trainee Program", "65¢/mi Box Truck (Non-CDL)", "No OTR experience required", "Paid path to upgrade"],
  },
];

export const PAY_PACKAGES = [
  { id: "team",        label: "$1 CPM",          title: "Company Team Driving", badge: "Highest CPM",      equipment: "Dry Van · Reefer · Flatbed", type: "cpm" },
  { id: "company-cpm", label: "85¢+ CPM",         title: "Company Driver",       badge: "OTR",              equipment: "Dry Van · Reefer · Flatbed", type: "cpm" },
  { id: "company-ppl", label: "30%+ PPL",          title: "Company Driver",       badge: "Per Practical Load", equipment: "Dry Van · Reefer",           type: "ppl" },
  { id: "lease",       label: "88%",               title: "Lease To Own",         badge: "Revenue Share",    equipment: "New Trucks Available",       type: "percent" },
  { id: "rent",        label: "88%",               title: "Rent Program",         badge: "Flexible",         equipment: "Flexible Terms",             type: "percent" },
  { id: "local-w2",    label: "$1,200–2,500/wk",   title: "Local / Regional W2",  badge: "Home Weekly",      equipment: "Home Time Friendly",         type: "weekly" },
  { id: "local-hr",    label: "$30/hr",            title: "Local Driver",         badge: "Home Daily",       equipment: "Hourly W2",                  type: "hourly" },
  { id: "trainee",     label: "$650–950/wk",       title: "Trainee Program",      badge: "No Experience",    equipment: "Get Your CDL",               type: "weekly" },
  { id: "boxtruck",    label: "65¢ CPM",           title: "Box Truck (Non-CDL)",  badge: "No CDL Needed",    equipment: "Box Truck",                  type: "cpm" },
];

export const PAY = [
  { trailer: "Company CPM", cpm: "85¢+", unit: "per mile", note: "OTR company drivers" },
  { trailer: "Team Driving", cpm: "$1", unit: "per mile", note: "Top CPM in the fleet" },
  { trailer: "Lease / Rent", cpm: "88%", unit: "revenue", note: "88% of gross revenue" },
];

export const BENEFITS = [
  { title: "All 48 States", desc: "We run coast to coast with no hiring area restriction. Chicago, Denver, Baltimore, Phoenix, Oklahoma — if there's freight, we're there." },
  { title: "Flexible Home Time", desc: "Preferably 2 weeks OTR — but we offer more or less. You tell us what works for your life." },
  { title: "2–4 Days Off + Vacations", desc: "Reset properly between runs with guaranteed home time and paid vacation." },
  { title: "New Trucks", desc: "Roll in the newest, best-maintained equipment on the road. Comfort and reliability, mile after mile." },
  { title: "Live + Dedicated Lanes", desc: "Steady dedicated freight from accounts including Kroger, Walmart, Dollar Tree, Family Dollar, and Target — or live loads coast to coast." },
  { title: "Weekly Pay", desc: "Consistent, on-time settlements every week. Know your money is coming." },
];

export const STATS = [
  { value: 48, suffix: "", label: "States Covered" },
  { value: 100, suffix: "%", label: "New Trucks" },
  { value: 2000, suffix: "+", label: "Drivers Rolling" },
  { value: 24, suffix: "/7", label: "Dispatch Support" },
];

export const PARTNERS = ["FREIGHTLINER", "VOLVO", "PETERBILT", "KENWORTH", "INTERNATIONAL"];

export const FAQS = [
  {
    q: "How much can I earn?",
    a: "Pay depends on your position: Company drivers earn 85¢+ CPM or $1 CPM team. Lease/Rent drivers keep 88% of gross revenue at a $3.50+ base rate. Local/Regional pays $1,200–$2,500/week W2. Local hourly pays $30/hr. Trainees start at $650–$950/week. Box Truck Non-CDL earns 65¢/mi.",
  },
  {
    q: "Do I need a CDL?",
    a: "Most positions require a CDL-A. However, our Box Truck position is Non-CDL and our Trainee Program is designed for drivers with little or no OTR experience who want to get started.",
  },
  {
    q: "Do I pay anything to get started?",
    a: "No. Drivers never pay us anything. There are no application fees and no hidden costs.",
  },
  {
    q: "Where do you run?",
    a: "All 48 states, coast to coast. There is no hiring area restriction — we onboard drivers nationwide. Key markets include Chicago and Joliet, IL; Denver, CO; Baltimore, MD; West Jefferson, OH; West Memphis, AR; Phoenix, AZ; and Oklahoma. We also service dedicated retail accounts including Kroger, Walmart, Dollar Tree, Family Dollar, and Target.",
  },
  {
    q: "What positions are available?",
    a: "Nine packages: Company Driver (CPM & PPL), Team Driving, Lease To Own, Rent Program, Local/Regional W2, Local Hourly, Trainee Program, and Non-CDL Box Truck. There's a seat for every driver.",
  },
  {
    q: "How does home time work?",
    a: "It depends on your position. Local drivers are home daily. Regional drivers are home weekly. OTR drivers can choose their frequency — we work around your schedule.",
  },
  {
    q: "What equipment will I drive?",
    a: "New trucks across all fleet positions. Dry Van, Flatbed, and Reefer trailers available depending on your preference.",
  },
  {
    q: "What is the Trainee Program?",
    a: "Our $650–$950/week paid trainee program is for drivers new to OTR. You ride with an experienced driver, learn the ropes, and start building your record — no OTR experience required.",
  },
  {
    q: "What is the Lease To Own program?",
    a: "Lease To Own means you're running at 88% of gross revenue in a truck you can eventually own. No credit check hurdles. Walk-away friendly terms. It's a real path to owning your truck, not a debt trap.",
  },
];

export const TESTIMONIALS = [
  { name: "Marcus D.", role: "Company OTR Driver", img: "https://images.unsplash.com/photo-1626712211690-8de4fe30177c?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", quote: "New truck, steady miles, and pay that actually reflects the work. Dispatch treats me like a person, not a number." },
  { name: "Antonio R.", role: "Lease To Own", img: "https://images.unsplash.com/photo-1633665503034-78f3628a86e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", quote: "The 88% lease program got me into a brand-new truck without the runaround. I'm building toward owning it outright." },
  { name: "James W.", role: "Local/Regional W2", img: "https://images.unsplash.com/photo-1762095996527-126e49ef9d72?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", quote: "Home every week, $2,100 in my pocket. Hylas matched me to the right lane on the first call." },
];

export const TRAILER_OPTIONS = ["Dry Van", "Flatbed", "Reefer", "Box Truck", "No Preference"];

export const POSITION_OPTIONS = [
  "$1 Company Team Driving (CPM)",
  "85¢+ Company Driver (CPM)",
  "30%+ Company Driver (PPL)",
  "88% Lease To Own",
  "88% Rent Program",
  "$1,200-2,500 Local/Regional W2",
  "$30/hr Local",
  "$650-950 Trainee Program (No Experience)",
  "65¢ Box Truck (Non-CDL)",
];

export const ENDORSEMENT_OPTIONS = ["Hazmat", "Tanker", "Doubles/Triples", "TWIC", "None"];

export const CDL_CLASS_OPTIONS = ["CDL-A", "CDL-B", "Class C", "No CDL"];

export const EXPERIENCE_OPTIONS = [
  "No Experience",
  "Less than 6 months",
  "6–12 months",
  "1–2 years",
  "2–3 years",
  "3+ years",
];
